import utils from './utils';
import Toggle from 'react-toggle';
import React, { useState } from 'react';
import { GFPlan } from '../../models/models';
import { Col, FormControl, FormGroup, Row, ButtonGroup, Button } from 'react-bootstrap';

interface Props {
  handleChange: (e: any) => void,
  paymentPlanStudents: number,
  planRecurringType: string,
  selectedPlan: GFPlan,
  loading: boolean,
}

enum RecurringType {
  Annual = 'Annual',
  Monthly = 'Monthly',
  Homeschool = 'Homeschool',
}

const PlanSelector: React.FunctionComponent<Props> = (props) => {
  const [prevRecurringType, setPrevRecurringType] = useState(RecurringType.Annual);
  const isHomeschool = utils.isHomeschool(props.selectedPlan);

  const handlePlanRecurringType = (e: any, value: string) => {
    const event = {
      preventDefault: () => null,
      currentTarget: {
        name: 'planRecurringType',
        value,
      },
    };

    props.handleChange(event);
  }

  const handlePaymentPlanStudents = (e: any) => {
    const value = isNaN(e.currentTarget.value) ? 25 : e.currentTarget.value;

    const event = {
      preventDefault: e.preventDefault,
      currentTarget: {
        name: 'paymentPlanStudents',
        value,
      },
    };

    props.handleChange(event);
  }

  const handleToggleHomeschool = (e: any) => {
    if (isHomeschool) {
      handlePlanRecurringType(e, prevRecurringType);
      return;
    }

    setPrevRecurringType(props.planRecurringType as RecurringType);
    handlePlanRecurringType(e, 'Homeschool');
  }

  return <section className="planSelector">
    <form>
      <Row>
        <Col xs={11}>
          <FormGroup>
            <ButtonGroup justified className="buttonGroup">
              <Button
                onClick={(e) => handlePlanRecurringType(e, RecurringType.Annual)}
                bsStyle={props.planRecurringType === RecurringType.Annual ? 'primary' : 'default'}
                disabled={props.loading || isHomeschool}
              >Annual</Button>
              <Button
                onClick={(e) => handlePlanRecurringType(e, RecurringType.Monthly)}
                bsStyle={props.planRecurringType === RecurringType.Monthly ? 'primary' : 'default'}
                disabled={props.loading || isHomeschool}
              >Monthly</Button>
            </ButtonGroup>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={5} xs={11}>
          <label>
            How many students will use GrammarFlip?
          </label>
        </Col>
        <Col md={1} xs={0}>
        </Col>
        <Col md={5} xs={11}>
          <FormGroup>
            <FormControl
              type="number"
              name="paymentPlanStudents"
              value={props.paymentPlanStudents}
              onChange={handlePaymentPlanStudents}
              disabled={props.loading || isHomeschool}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={11}>
          <FormGroup className="homeschool">
            <Toggle
              icons={false}
              checked={isHomeschool}
              onChange={handleToggleHomeschool}
              className="gf-toggle"
              disabled={props.loading}
            />
            <label>
              Or choose a Homeschool Subscription.<br/>
              5 Students, Annual Only
            </label>
          </FormGroup>
        </Col>
      </Row>
    </form>
  </section>;
}

export default PlanSelector;
